import { ref, computed, reactive } from 'vue'
import { defineStore } from 'pinia'

export const useSessionDataStore = defineStore('sessionDataStore', () => {
    const dataValues = ref([])
    const dataLabels = ref([])
    const toggleLegend = ref(true);
    const colors = ref([])
    const colorsCalc = ref([])
    const baselineCdA = ref(0.2)
    // const targetWatts = ref(160)
    // const targetDistance = ref(90)
    const airDensity = ref (1.18)
    const crr = ref (0.005)
    const eta = ref (0.98)
    
    const sessionData = ref([])

    const calcSeries = ref([])
    const timeSeries = ref([])

    function populateSessions(sessions){
        sessions.forEach(session => {
            sessionData.value.push(
                {
                    id: session.id,
                    collection: session.collection,
                    name: session.name,
                    timeStamp: session.timestamp.toDate().toDateString(),
                    testCount: session.tests.length
                }
            )
        })
    }

    function populate(session) {
        dataLabels.value = []
        dataValues.value = [] 
        
        session.groupedTests.forEach(element => {
            dataValues.value.push(element.cda.toFixed(3))
            dataLabels.value.push(element.name.substring(0, 15))
            colors.value.push("#008FFB")
        })
        //console.log("Colors")
        //console.log(colors)
    }

    function getBaselineCda(session){
        var baseline = 0.0
        session.groupedTests.forEach(element => {
            if (element.name.toLowerCase().trim() === 'baseline'){
                //console.log("baseline cda=", element.cda)
                baseline = element.cda
            }else{
                //console.log(" not baseline name=", element.name, " cda=", element.cda)
            }
        })
        if (baseline === 0.0) {
            if (session.tests.length > 0) {
                //console.log("no baseline cda=", session.tests[0].cda)
                baseline = session.tests[0].cda
            } else {
                baseline = 0.25
            }
        }
        return baseline
    }

    function calculateSavings(session, targetDistance, targetWatts){
        calcSeries.value = []
        timeSeries.value = []
        colorsCalc.value = []
        baselineCdA.value = getBaselineCda( session)
        //console.log("baseline cda=", baselineCdA.value, ' target distance=', targetDistance)
        let speedBaseline = calculateSpeed(baselineCdA.value,
            targetWatts,
            airDensity.value,
            session.totalMass,
            crr.value,
            eta.value)
        
        let wattsBaseline = calculateForceToOvercomeAir(baselineCdA.value, airDensity.value , speedBaseline)
        var timeBaseline = (targetDistance * 1000) / speedBaseline
        timeBaseline = timeBaseline.toFixed()
        session.groupedTests.forEach(element => {
            let speedActual = calculateSpeed(element.cda,
                targetWatts,
                airDensity.value,
                session.totalMass,
                crr.value,
                eta.value)

                let wattsActual = calculateForceToOvercomeAir(element.cda, airDensity.value , speedBaseline)
                let timeTarget = (targetDistance * 1000) / speedActual

                let wattsSaved = wattsBaseline - wattsActual
                let timeSaved = timeBaseline - timeTarget.toFixed()
                //console.log("time savings=", timeSaved)
                if (timeSaved == 0){
                    timeSaved = 0.1
                }
                calcSeries.value.push(wattsSaved.toFixed())
                timeSeries.value.push(timeSaved.toFixed())
                if (timeSaved < 0){
                    colorsCalc.value.push("#008FFB")
                }else{
                    colorsCalc.value.push("#008FFB")
                }
        })
        return calcSeries.value
    }

    function calculateAveragePower(session){
        if (session.groupedTests.length == 0){
            return 0
        }else{
            let totalPower = 0.0
            session.groupedTests.forEach(element => {
                totalPower += element.averagePower
            })
            return (totalPower / session.groupedTests.length).toFixed()
        }
    }

    function toggleTheLegend() {
        toggleLegend.value = !toggleLegend.value;
    }

    function calculateForceToOvercomeAir(cda, rho, speed) {
        
        let wattsToOverComeAir = (0.5 * cda * rho * Math.pow(speed, 2.0)) * speed
        
        return wattsToOverComeAir
    }

    function calculateSpeed(cda, power, rho, totalMass, crr, eta = 0.97) {
        let gravity = 9.80665
        let watts = power * eta
        let A = 0.5 * rho * cda
        let B = totalMass * gravity * crr
        let C = -1.0 * watts
        let Q = C/A
        let P = B/A
        
        let L = -Q/2 + Math.pow(Math.pow(Q,2.0)/4.0+Math.pow(P,3.0)/27.0,0.5)
        let M = -1*Q/2 - Math.pow(Math.pow(Q,2.0)/4.0+Math.pow(P,3.0)/27.0,0.5)
        
        var N = 0.0
        var O = 0.0
        
        if (L < 0.0){
            N = -1*Math.pow(Math.abs(L),1.0/3.0)
        }
        else{
            N = Math.pow(L,1.0/3.0)
        }
        
        if (M < 0.0){
            O  = -1*Math.pow(Math.abs(M),1.0/3.0)
        }
        else{
            O = Math.pow(M,1.0/3.0)
        }
        
        let speed = N + O
        return speed
    }


    return { dataValues, dataLabels, toggleLegend, populate, populateSessions, toggleTheLegend, colors, calcSeries, timeSeries, calculateSavings, colorsCalc, calculateAveragePower }
})